(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('SubscribeDetailController', SubscribeDetailController);

    SubscribeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Subscribe', 'Race', 'Runner'];

    function SubscribeDetailController($scope, $rootScope, $stateParams, previousState, entity, Subscribe, Race, Runner) {
        var vm = this;

        vm.subscribe = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:subscribeUpdate', function(event, result) {
            vm.subscribe = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
